import React,{ useEffect, useRef, useState } from "react";
import { useDrag, useDrop } from 'react-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDeleteLeft, faClone } from "@fortawesome/free-solid-svg-icons"

import SearchableSelect from "util/component/SearchableSelect";
import { useDispatch } from "react-redux";

const DND_ITEM_TYPE = "row";
const TRIANGLE_RED = '#F84F31';
const TRIANGLE_GREEN = '#23c552';
const TRIANGLE_GRAY = '#b3b3b3';

const autoResizeTextarea = (e) => {
    const textarea = e.target
    textarea.style.height = "12px";
    let height = textarea.scrollHeight; // 높이
    if (height < 12) {
        height = 12;
    }
    textarea.style.height = `${height}px`;
}

const CustomTextArea = ({ value, changed, readOnly, name, style = {},onViewChange }) => {
    const [_value, _setValue] = useState(value)
    
    const dispatch = useDispatch();

    const _ref = useRef(null);
    useEffect(() => {
        _setValue(value);
    }, [value])

    const _onFocus = (e) => {
        try {
            dispatch({type: "FOCUS_TD", td: _ref.current})
        } catch(e) {}
    }
    const _onBlur = (e) => {
        try {
            dispatch({type: "BLUR_TD"});
            changed(e);
        } catch(e) {}
    }

    return <textarea
        ref={_ref}
        style={{...style, height: (_ref.current?.scrollHeight || "14")+"px"}}
        name={name}
        value={_value}
        onChange={(e) => {_setValue(e.target.value); onViewChange(e);}}
        onKeyUp={(e) => {autoResizeTextarea(e)}}
        onBlur={_onBlur}
        onFocus={_onFocus}
        maxLength={700}
        readOnly={readOnly}
    />
}

const Rows = ({rowData, index, moveRow, changed, deleted, copied, pr,onOpen,soSelected,handleClickSQTable,RevCmptCheckList,isCopy,isSheetCode,SOOptions,soChanged }) => {
    const dropRef = React.useRef(null)
    const dragRef = React.useRef(null)

    const [sSelected, setSSelected] = useState({
        label: false,
        labelType:"",
        desc: false,
        descType:""
    });

    const sheetReview = RevCmptCheckList !== undefined ? RevCmptCheckList.filter(sheet => sheet.uniqueCode === rowData.uniqueCode) : undefined;
    const sheetData1 = sheetReview !== undefined ? sheetReview.findIndex((key) => key.celNm === 'label') : undefined;
    const sheetData2 = sheetReview !== undefined ? sheetReview.findIndex((key) => key.celNm === 'desc') : undefined;
    let label;
    let labelType;
    let desc ;
    let descType ;
    if(sheetData2 !== undefined && sheetReview[sheetData2] !== undefined && sheetData2 > -1){
        desc = true;
        descType = sheetReview[sheetData2].cmptType ==='R' ? TRIANGLE_RED : TRIANGLE_GREEN
    }else{
        desc = true;
        descType = TRIANGLE_GRAY
    }
    if(sheetData1 !== undefined && sheetReview[sheetData1] !== undefined && sheetData1 > -1){
        label = true;
        labelType = sheetReview[sheetData1].cmptType ==='R' ? TRIANGLE_RED : TRIANGLE_GREEN
    }else{
        label = true;
        labelType = TRIANGLE_GRAY
    }

    const repeatYN = [
        {value: "N", label: "N"},
        {value: "Y", label: "Y"},
    ]

    const [, drop] = useDrop({
        type: DND_ITEM_TYPE,
        accept: DND_ITEM_TYPE,
        hover(item, monitor) {
            if (!dropRef.current) {
                return
            }
            const dragIndex = item.index
            const hoverIndex = index
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) {
                return
            }
            // Determine rectangle on screen
            const hoverBoundingRect = dropRef.current.getBoundingClientRect()
            // Get vertical middle
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
            // Determine mouse position
            const clientOffset = monitor.getClientOffset()
            // Get pixels to the top
            const hoverClientY = clientOffset.y - hoverBoundingRect.top
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return
            }
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return
            }
            // Time to actually perform the action
            moveRow(dragIndex, hoverIndex)
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            item.index = hoverIndex
        },
    })

    const [{ isDragging }, drag, preview] = useDrag({
        item: { index },
        type: DND_ITEM_TYPE,
        collect: monitor => ({
            isDragging: monitor.isDragging(),
        }),
    })

    const opacity = isDragging ? 0 : 1

    preview(drop(dropRef))
    drag(dragRef)

    // code
    // const soSeqOrder = (seq) => {
    //     if (!!seq) {
    //         // Temp Save 모드 값이 불려오지는 것으로 그대로 출력
    //         return ('S'+('00' + (seq-1)).slice(-2));
    //     } else {
    //         let i = index;
    //         return ('S'+('00' + i).slice(-2));
    //     }
    // }
    return <tr ref={dropRef} style={{ opacity }}>
            <td ref={dragRef}>{index+1}</td>
{/*        <td>
            <input type="text" name="soSeq" defaultValue={rowData.seqCode} className="so-code" readOnly/>  //최종버전의 input태그
             {soSeqOrder(rowData.seqCode)}
             {soSeqOrder(rowData.soSeq)}
             {rowData.seqCode}

             <input type="text" name="soSeq" defaultValue={"S"+('00' + `${rowData.soSeq}`).slice(-2)} className="so-code " readOnly />
             <input type="text" name="soSeq" defaultValue={soSeqOrder(rowData.soSeq)} className="so-code " readOnly />
        </td>*/}
            <td
            >
        {/* {label? <div style={{cursor:"pointer",position: "absolute", backgroundColor: labelType, top: 0, right: 0, width: 15, height: 15, transform: "translateX(7px) translateY(-7px) rotateZ(45deg)"}}
                             onClick={() => {
                                 onOpen({name:"label"},rowData.uniqueCode);
                                 handleClickSQTable("label",index);
                             }}></div> : ""} */}
            {(isSheetCode && isCopy === 'Y') || !isSheetCode  && index !== 0?
                <SearchableSelect
                    value={rowData.code}
                    onChange={(val) => changed({target: {name: "step", value: val}}, index)}
                    search={true}
                    options={SOOptions}
                    name="step"
                /> :
                <input type="text" value={rowData.label} className="so-input " readOnly/>}
            </td>

            <td style={{overflow:"hidden",position: "relative"}}>
            {desc ? <div style={{
                cursor: "pointer",
                position: "absolute", backgroundColor: descType, top: 0, right: 0, width: 15, height: 15, transform: "translateX(7px) translateY(-7px) rotateZ(45deg)"}}
                            onClick={() =>{
                                onOpen({name:"desc"},rowData.uniqueCode)
                                handleClickSQTable("desc",index);
                            }}></div> : ""}

                <CustomTextArea placeholder="Description" name="desc" value={rowData.desc} changed={e => changed(e, index)} onViewChange={(e) => changed(e, index)}/>
            </td>
            <td style={pr === "USP" ? {backgroundColor: "#0001"} : null}>
                <SearchableSelect
                    isDisabled={pr === "USP"}
                    name="repeat"
                    defaultValue={rowData.repeat}
                    value={rowData.repeat}
                    options={repeatYN}
                    textAlign={"center"}
                    onChange={(e) => changed({target: {name: "repeat", value: e.value}}, index)}
                />
            </td>
            <td className={"cancle actions"} onClick={(e) => deleted(index, e)}>
                {/* <FontAwesomeIcon icon={faDeleteLeft} /> */}
                del
            </td>
            <td className={"copy actions"} onClick={(e) => copied(index, e)} data-name={rowData.label}>
                {/* <FontAwesomeIcon icon={faClone} /> */}
                copy
            </td>
        </tr>
    
}

export default Rows;
